import { Link as RouterLink, useParams } from "react-router-dom";
import {
  Box,
  Breadcrumbs,
  Button,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import {
  ChevronRight as ChevronRightIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import { motion } from "motion/react";
import { fadeInOut } from "~/lib/animations";
import { IntegrationRecommendedPolicies } from "../components/IntegrationRecommendedPolicies";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

export interface K8AddPoliciesProps {
  scope: SpaceScope | OrganizationScope;
}

export const K8AddPoliciesPage = ({ scope }: K8AddPoliciesProps) => {
  const { integrationId } = useParams();

  const breadcrumbs = [
    <Link
      key="/space/overview"
      component={RouterLink}
      to={`/space/overview?${scope.params}`}
      display="flex"
    >
      <HomeIcon fontSize="inherit" />
    </Link>,
    <Link
      key="/space/integrations"
      component={RouterLink}
      to={`/space/integrations?${scope.params}`}
    >
      Integrations
    </Link>,
    <Link
      key="/space/integrations"
      component={RouterLink}
      to={`/space/integrations/add?${scope.params}`}
    >
      Add
    </Link>,
    <Typography key={1}>Kubernetes</Typography>,
    <Typography key={2}>Recommended Policies and Query Packs</Typography>,
  ];

  return (
    <Box component={motion.div} {...fadeInOut}>
      <Breadcrumbs sx={{ mb: 3 }} separator="›">
        {breadcrumbs}
      </Breadcrumbs>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 3 }}>
        Recommended Policies and Query Packs
      </Typography>

      <Paper sx={{ px: 2 }}>
        <IntegrationRecommendedPolicies
          {...{ scope }}
          filterTypes={["kubernetes"]}
        />
      </Paper>
      <Box
        sx={{
          display: "flex",
          placeContent: "flex-end",
          mt: 4,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to={`/space/integrations/kubernetes/${integrationId}?${scope.params}`}
          endIcon={<ChevronRightIcon style={{ fontSize: 30 }} />}
          data-name="k8s-finish-set-policies-button"
        >
          show integration
        </Button>
      </Box>
    </Box>
  );
};
